import { ConfigurationTab, type ConfigurationTabEnum } from "../types";

export const isSummaryTab = (tab: ConfigurationTabEnum) => tab === ConfigurationTab.Summary;
